import React, {useState} from 'react';

export default function FacilityModal({ initial, onClose, onSave }) {
  const [form, setForm] = useState(() =>
    initial ? { ...initial } : { name: '', description: '', price: '', charge_type: 'Per Hour' }
  );
  const [error, setError] = useState('');

  const chargeTypes = ['Per Hour', 'Per Use', 'Per Day', 'Per Person', 'Per Booking', 'Free'];

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: name === 'price' ? value.replace(/[^0-9]/g, '') : value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.name || !form.charge_type) {
      setError('Name and Charge Type are required.');
      return;
    }
    // Validation: price/charge_type consistency
    if (Number(form.price) === 0 && form.charge_type !== 'Free') {
      setError('If price is 0, charge type must be Free.');
      return;
    }
    if (form.charge_type === 'Free' && Number(form.price) !== 0) {
      setError('If charge type is Free, price must be 0.');
      return;
    }
    // Auto-correct for user experience (optional, can remove if strict)
    let payload = { ...form };
    if (form.charge_type === 'Free') payload.price = 0;
    if (Number(form.price) === 0) payload.charge_type = 'Free';
    onSave({ ...payload, price: payload.price ? Number(payload.price) : 0 });
    onClose();
  };

  return (
    <div className="facility-modal-overlay">
      <div className="facility-modal">
        <h3>{initial ? 'Edit Facility' : 'Add Facility'}</h3>
        <form onSubmit={handleSubmit}>
          <div className="modal-row">
            <label>Name</label>
            <input name="name" value={form.name} onChange={handleChange} required />
          </div>
          <div className="modal-row">
            <label>Description</label>
            <textarea name="description" value={form.description} onChange={handleChange} />
          </div>
          <div className="modal-row">
            <label>Price</label>
            <input name="price" value={form.price} onChange={handleChange} />
          </div>
          <div className="modal-row">
            <label>Charge Type</label>
            <select name="charge_type" value={form.charge_type} onChange={handleChange}>
              {chargeTypes.map(type => <option key={type} value={type}>{type}</option>)}
            </select>
          </div>
          {error && <div className="modal-error">{error}</div>}
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn-cancel">Cancel</button>
            <button type="submit" className="btn-save">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}
